module.exports = function getResource(label, vars = []) {
    const resources = {
        selectShoppingExperience: 'Select shopping experience',
        unitedStates: 'United States'
    };
    return resources[label];
};
